import { motion } from 'framer-motion'
import React, { Fragment, useEffect, useRef, useState } from 'react'
import toast from 'react-hot-toast'
import { AiFillSafetyCertificate, AiOutlineExclamationCircle, AiTwotonePhone } from 'react-icons/ai'
import { useMutation } from 'react-query'
import { useLocation } from 'react-router-dom'
import styled from 'styled-components'

import { getSalesInfo, getSmsCode, getUserOfSales, register } from '@/api/login'
import CodeModal from '@/components/CodeModal'
import SubmitModal from '@/components/SubmitModal'
import { loginStore, useRecoilState, useRecoilValue, useSetRecoilState } from '@/store'
import { getParams } from '@/utils/tool'

import Area from '../Area'
import Slider from '../Slider'
const { stepState, areaState, mobileState, needSliderState } = loginStore

export default function Index() {
  const location = useLocation()
  const setStep = useSetRecoilState(stepState)
  const [successState, setSuccessState] = useState(false)
  const [qwCodeState, setQwCodeState] = useState(false)
  const [areaCode, setAreaCode] = useRecoilState(areaState)
  const [mobile, setMobile] = useRecoilState(mobileState)
  const [mobileError, setMobileError] = useState('')
  const [input, setInput] = useState('')
  const [codeError, setCodeError] = useState('')
  const [agreement, setAgreement] = useState(true)
  const [errorMsg, setErrorMsg] = useState('')
  const [countdownText, setCountdownText] = useState(60)
  const needSlider = useRecoilValue(needSliderState) // 是否需要滑块验证
  const countdownRef = useRef<string | number | NodeJS.Timeout | undefined>(undefined)
  const [qrCode, setQrCode] = useState('')

  const handleSubmit = useMutation(() => {
    const { s, t, channel, code, come, area, bd_vid } = getParams(location.search)
    return register({
      type: 'REG',
      areaCode,
      mobile,
      code: input,
      fullUrl: window.location.href,
      channel: channel || (code && code.split('-')[1]) || 51, // 取地址栏或者51
      deviceInfo: JSON.stringify(window.getDeviceInfo(navigator.userAgent)) // 取设备信息
    })
  })
  useEffect(() => {
    if (handleSubmit.status === 'error') {
      setErrorMsg('注册失败，请重试')
    }
    if (handleSubmit.data) {
      if (handleSubmit.data.status !== 0) {
        setErrorMsg(handleSubmit.data.msg)
      } else {
        toast.success('注册成功')
        getSales(handleSubmit.data.data.userId)
      }
    }
  }, [handleSubmit.status])

  const getSales = async (uid: number) => {
    const salesData: any = await getUserOfSales(uid)
    const { code, payload } = salesData
    if (code === 0) {
      const { salesId, uid } = payload
      if (salesId) {
        const salesInfo = (await getSalesInfo({ adminId: salesId, uid: uid })) as any
        if (salesInfo.code === 0) {
          setQrCode(salesInfo.payload)
          setQwCodeState(true)
          localStorage.setItem('localMobile', mobile)
        } else {
          toast.success('您的课程已领取成功，请等待老师与您联系～')
          setStep(0)
        }
      } else {
        setErrorMsg('暂无销售信息')
      }
    } else {
      setErrorMsg(salesData.errors)
    }
  }

  const smsCode = useMutation(({ sessionId, sig, token }: { sessionId: string | undefined; sig: string | undefined; token: string | undefined }) => {
    return getSmsCode({
      areaCode,
      mobile,
      sessionId,
      sign: sig,
      scene: 'nc_login',
      token,
      type: 'REG'
    })
  })

  const countdown = () => {
    countdownRef.current = setInterval(() => {
      setCountdownText((v) => {
        const end = v - 1
        if (end === 0) {
          clearInterval(countdownRef.current)
          return 60
        } else {
          return end
        }
      })
    }, 1000)
  }

  useEffect(() => {
    if (smsCode.status === 'error') {
      setErrorMsg('获取验证码失败，请重试')
      needSlider && window.nc.reset()
    }
    if (smsCode.data && smsCode.data.status !== 0) {
      setErrorMsg(smsCode.data.msg)
      needSlider && window.nc.reset()
    } else {
      if (smsCode.status === 'success') {
        toast.success(smsCode.data.data)
        countdown()
      }
    }
  }, [smsCode.status])

  const changeAreaCode = (e: string) => {
    setAreaCode(e)
    setMobile('')
    setMobileError('')
    setErrorMsg('')
  }

  const inputChange = (e: React.ChangeEvent<HTMLInputElement>, type: string) => {
    const val = e.target.value
    if (type === 'mobile') {
      setMobile(val)
    } else if (type === 'input') {
      setInput(val)
    } else {
      setAgreement(e.target.checked)
    }
  }

  useEffect(() => {
    if (areaCode === '+86' && mobile.length === 11) {
      if (/^1[3456789]\d{9}$/.test(mobile)) {
        setMobileError('success')
        setErrorMsg('')
      } else {
        // 验证手机号
        setMobileError('error')
        setErrorMsg('请输入正确的手机号')
      }
    } else if (areaCode !== '+86' && mobile.length >= 7) {
      setMobileError('success')
      setErrorMsg('')
    } else {
      setMobileError('')
      setErrorMsg('')
    }
  }, [mobile])

  useEffect(() => {
    if (input.length === 6) {
      setCodeError('success')
      setErrorMsg('')
    } else {
      setCodeError('')
      setErrorMsg('')
    }
  }, [input])

  const ncSign = (data) => {
    setErrorMsg('')
    smsCode.mutate(data)
  }

  const resetNc = () => {
    // 不需滑块
    if (!needSlider) {
      smsCode.mutate({
        sessionId: undefined,
        sig: undefined,
        token: undefined
      })
      return
    }
    // 需滑块
    if (countdownText === 60 && mobileError === 'success') {
      setErrorMsg('请先进行滑动验证')
      window.nc.reset()
    }
  }

  const closeQrCode = (state: boolean) => {
    setQwCodeState(state)
    setStep(0)
  }

  return (
    <Container className="h-full w-full flex flex-col items-start justify-center">
      <div className="text-[24px] text-[#333]">注册领取试听课</div>
      <div className="w-[350px] my-[30px]">
        <div
          className={`w-full h-[40px] border-b border-[#ddd] flex items-center justify-center mb-[30px] ${
            mobileError === 'success' ? 'border-[#36c236]' : ''
          } ${mobileError === 'error' ? 'border-[red]' : ''}`}
        >
          <div className="w-[40px] h-full flex items-center justify-center">
            <AiTwotonePhone className="text-[28px] text-[#999]" />
          </div>
          <Area onChange={changeAreaCode} areaCode={areaCode} />
          <div className="flex-1 h-full relative">
            <input
              value={mobile}
              onChange={(e) => inputChange(e, 'mobile')}
              className="absolute h-full w-full p-[10px] border-0 outline-none text-[20px] text-[#656565]"
              placeholder="请输入手机号码"
              maxLength={11}
            ></input>
          </div>
        </div>

        <div
          className={`w-full h-[40px] border-b border-[#ddd] flex items-center justify-center mb-[30px] ${
            codeError === 'success' ? 'border-[#36c236]' : ''
          } ${codeError === 'error' ? 'border-[red]' : ''}
        `}
        >
          <div className="w-[40px] h-full flex items-center justify-center">
            <AiFillSafetyCertificate className="text-[28px] text-[#999]" />
          </div>
          <div className="flex-1 h-full relative">
            <input
              value={input}
              onChange={(e) => inputChange(e, 'input')}
              className="absolute h-full w-full p-[10px] border-0 outline-none text-[20px] text-[#656565]"
              placeholder="请输入验证码"
              maxLength={6}
            ></input>
          </div>
          <div className="w-[120px] h-full flex items-center justify-center">
            <button
              onClick={resetNc}
              className={`btn-def w-full h-[36px] rounded-full flex items-center justify-center outline-none text-[16px] text-[#FFF]
              ${countdownText === 60 && mobileError === 'success' ? 'btn-active' : ''}
            `}
            >
              {countdownText !== 60 ? `重新获取${countdownText}s` : '获取验证码'}
            </button>
          </div>
        </div>
        {needSlider ? (
          <div className={`h-[34px] mb-[30px] ${mobileError === 'success' ? '' : 'hidden'}`}>
            <Slider ncSign={ncSign} />
          </div>
        ) : null}
        <div className="text-[14px] text-[#333] flex items-center justify-start flex-wrap">
          <input checked={agreement} onChange={(e) => inputChange(e, 'agreement')} className="mr-[5px] cursor-pointer" type="checkbox" /> 我已阅读并同意{' '}
          <a target="_blank" className="text-[#1890FF]" href={`${import.meta.env.VITE_APP_home}/v2/introductionOfTeachers/proto/`}>
            《用户注册协议》
          </a>
          <a target="_blank" className="text-[#1890FF]" href={`${import.meta.env.VITE_APP_home}/v2/introductionOfTeachers/secret/`}>
            《隐私政策》
          </a>
          <a target="_blank" className="text-[#1890FF]" href={`${import.meta.env.VITE_APP_home}/1v1h5pages/student/childrenPrivacy`}>
            《未成年人个人信息处理规则》
          </a>
        </div>
      </div>
      {errorMsg ? (
        <div className="text-[#e82925] text-[14px] flex items-center mb-[20px]">
          <AiOutlineExclamationCircle className="mr-[5px]" />
          {errorMsg}
        </div>
      ) : null}
      <div className="w-[350px]">
        <div className="w-full mb-[20px]">
          <button
            disabled={!(codeError === 'success' && mobileError === 'success' && agreement)}
            onClick={() => handleSubmit.mutate()}
            className={`btn-def w-[260px] h-[48px] rounded-full flex items-center justify-center outline-none text-[20px] text-[#FFF]
            ${codeError === 'success' && mobileError === 'success' && agreement ? 'btn-active' : ''}
            `}
          >
            注册
          </button>
        </div>
        <div className="text-[14px] text-[#333333]">
          已有账号，
          <span className="cursor-pointer text-[#ff783a]" onClick={() => setStep(0)}>
            直接登录
          </span>
        </div>
      </div>
      <SubmitModal
        show={successState}
        onClose={() => {
          setSuccessState(false)
          setStep(0)
        }}
        area={areaCode}
      />
      {qwCodeState && <CodeModal qrCode={qrCode} setQwCodeState={closeQrCode} />}
    </Container>
  )
}

const Container = styled(motion.div)`
  .btn-def {
    background: linear-gradient(270deg, #888, #ccc);
  }
  .btn-active {
    background: linear-gradient(90deg, #ff7839, #fe4844);
  }
`
